
import { ref } from 'vue'

export const tabs = ref( [ { 

  id: 'respiratory', 
  
  label: 'Respiratory',

  active: true,

  visible: true,

  styles: {

    bgColor: 'bg-respiratory',

    border: 'border-respiratory',

    borderHover: 'hover:border-respiratory'

  }

},{ 

  id: 'gastrointestinal', 
  
  label: 'Gastrointestinal',

  active: false,

  visible: true,

  styles: {

    bgColor: 'bg-gastrointestinal',

    border: 'border-gastrointestinal',

    borderHover: 'hover:border-gastrointestinal'

  }

}, { 
  
  id: 'meningitis', 
  
  label: 'Meningitis/Encephalitis',

  active: false,

  visible: true,

  styles: {

    bgColor: 'bg-meningitis',

    border: 'border-meningitis',

    borderHover: 'hover:border-meningitis'

  }

}, { 
  
  id: 'tropical-fever', 
  
  label: 'Tropical Fever',

  active: false,

  visible: true,

  styles: {

    bgColor: 'bg-tropical-fever',

    border: 'border-tropical-fever',

    borderHover: 'hover:border-tropical-fever'

  }

}, { 
  
  id: 'bloodstream-infections', 
  
  label: 'Bloodstream Infections',

  active: false,

  visible: true,

  styles: {

    bgColor: 'bg-bloodstream-infections',

    border: 'border-bloodstream-infections',

    borderHover: 'hover:border-bloodstream-infections'

  }

} ] )
